<template>
  <div>
    <h1>TEAM USERS GROUPS</h1>
    <v-layout>
      <v-text-field v-model="nameGroup" solo label="Name"></v-text-field>
      <v-btn :disabled="(nameGroup != null && nameGroup != '') ? false : true" @click="createUsersGroup" text color="success">Add
        new group</v-btn>
    </v-layout>

    <v-data-table v-if="groups!=null && groups.length" :headers="[
        /* { text: 'NUMBER', value: 'id_playlist' }, */
        { text: 'ID', value: 'id' },
        { text: 'INDEX ORDER', value: 'index_order' },
        { text: 'NAME', value: 'name' },
        { text: 'EDIT', value: 'editGroup' },
        { text: 'DELETE', value: 'actionsGroup' },


      ]" :items="groups">
        <template v-slot:item.actionsGroup="{ item }">
          <v-btn @click="deleteItemGroup(item)" text color="error">DELETE</v-btn>
        </template>
        <template v-slot:item.editGroup="{ item }">
          <v-btn @click="editGroup(item)" text color="info">Edit</v-btn>
        </template>
      </v-data-table>
      <v-dialog v-model="dialogGroup" v-if="selectedGroup != null" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            Updating
          </v-card-title>

          <v-card-text>
            <v-text-field v-model="selectedGroup.name" label="Name"></v-text-field>
          </v-card-text>
          <v-card-text>
            <v-text-field v-model="selectedGroup.index_order" label="Index order"></v-text-field>
          </v-card-text>
          
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" flat @click="updateGroup">
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <v-divider></v-divider>






    <h1>TEAM USERS</h1>
    <v-layout>
      <v-text-field v-model="name" solo label="Name"></v-text-field>
      <v-text-field style="margin-left: 10px;" v-model="surname" solo label="Surname"></v-text-field>
      <v-btn :disabled="(name != null && name != '') && (surname != null && surname != '') ? false : true" @click="createUser" text
        color="success">Add new user</v-btn>
    </v-layout>
    <v-layout>
      <v-text-field @input="seatchMethod" v-model="search" solo label="Search"></v-text-field>
    </v-layout>
    <v-layout v-if="team != null">
      <v-data-table v-if="team.length" :headers="[
        /* { text: 'NUMBER', value: 'id_playlist' }, */
        { text: 'ID', value: 'id' },
        { text: 'NAME', value: 'name' },
        { text: 'SURNAME', value: 'surname' },
        { text: 'INDEX ORDER', value: 'index_order',sortable: false },
        { text: 'GROUP', value: 'group',sortable: false },
        { text: 'EDIT', value: 'edit' },
        { text: 'DELETE', value: 'actions' },


      ]" :items="filteredTeam">
        <template v-slot:item.actions="{ item }">
          <v-btn @click="deleteItem(item)" text color="error">DELETE</v-btn>
        </template>
        <template v-slot:item.edit="{ item }">
          <v-btn @click="edit(item)" text color="info">Edit</v-btn>
        </template>
        <template v-slot:item.group="{ item }">
          {{ item.id_group != null && item.id_group != 0 ? groups.find(x=>x.id == item.id_group) != null? groups.find(x=>x.id == item.id_group).name :'-' : '-'}}
        </template>
      </v-data-table>
      <v-dialog v-model="dialog" v-if="selected != null" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            Updating
          </v-card-title>
          <v-card-text>
            <v-text-field type="number" min="0" v-model="selected.index_order" label="INDEX ORDER"></v-text-field>
          </v-card-text>
          <v-card-text>
            <v-select
              label="GROUP"
              v-model="selected.id_group"
              :items="groups"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-card-text>
          <v-card-text>
            <v-text-field v-model="selected.name" label="Name"></v-text-field>
          </v-card-text>
          <v-card-text>
            <v-text-field v-model="selected.surname" label="Surname"></v-text-field>
          </v-card-text>
          <v-card-text>
            <v-text-field v-model="selected.city" label="City"></v-text-field>
          </v-card-text>
          <v-card-text>
            <v-text-field v-model="selected.speciality" label="Speciality"></v-text-field>
          </v-card-text>
          <v-card-text>
            <label for="text_input">Text</label>
            <br>
            <textarea v-model="selected.text" id="text_input"
              style="width: 100%;border: 1px solid #383838;border-radius: 10px;"></textarea>
          </v-card-text>
          <v-card-text>
            <v-switch v-model="selected.position" label="Big frame" />
          </v-card-text>
          <v-card-text>
            <v-text-field v-model="selected.web_link" label="Web"></v-text-field>
          </v-card-text>
          <v-card-text>
            <v-text-field v-model="selected.instagram_link" label="Instagram"></v-text-field>
          </v-card-text>
          <v-card-text>
            <v-text-field v-model="selected.facebook_link" label="Facebook"></v-text-field>
          </v-card-text>
          <v-card-text>
            <v-text-field v-model="selected.linkedin_link" label="Linked In"></v-text-field>
          </v-card-text>
          <v-card-text>
            <v-text-field v-model="selected.youtube_link" label="YouTube"></v-text-field>
          </v-card-text>
          <v-card-text>
            <v-text-field v-model="selected.whatsapp_link" label="WhatsApp"></v-text-field>
          </v-card-text>
          <v-card-text>
            <img style="object-fit: cover;" v-if="selected.image != null && selected.image != ''" :src="selected.image"
              width="100px" height="100px" />
            <input type="file" ref="fileInput" style="display: none" accept=".png, .jpeg, .jpg"
              @change="handleFileChange">
            <v-btn @click="openFileInput" text color="success">Add image</v-btn>
          </v-card-text>

          <v-divider></v-divider>


          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" flat @click="update">
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios';

export default {
  data() {
    return {
      name: null,
      surname: null,
      team: null,
      groups: null,
      filteredTeam: null,
      search: '',
      selected: null,
      selectedGroup: null,
      dialog: false,
      dialogGroup: false,
      nameGroup: null,
    }
  },
  methods: {
    openFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = async () => {
        const base64Data = reader.result;
        let obj = {
          image: base64Data,
          id: this.selected.id
        }
        await axios.post("/admin/team/updateImage", obj).then((res) => {
          // this.sync();
          this.selected.image = res.data.url;
        })

      };
      reader.readAsDataURL(file);
    },
    async update() {
      if (this.selected.name != null && this.selected.name != "" && this.selected.surname != null && this.selected.surname != "")
        await axios
          .post("/admin/team/update", this.selected).then(() => {
            this.sync();
            this.dialog = false;
          })
    },
    async updateGroup() {
      if (this.selectedGroup.name != null && this.selectedGroup.name != "")
        await axios
          .post("/admin/teamGroup/update", this.selectedGroup).then(() => {
            this.syncGroups();
            this.dialogGroup = false;
          })
    },
    edit(item) {
      this.selected = Object.assign({}, item);
      this.dialog = true;
    },

    editGroup(item) {
      this.selectedGroup = Object.assign({}, item);
      this.dialogGroup = true;
    },
    seatchMethod(val) {
      if (this.search == '') {
        this.filteredTeam = this.team.sort((a, b) => {
          const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
          const nameB = b.name.toUpperCase();

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0; // Names are equal
        });
        ;;
      }
      else {
        this.filteredTeam = this.team.filter(element => {
          return (element.name + ' ' + element.surname).includes(this.search)
        });
      }
    },
    async createUser() {
      if (this.name != null && this.name != "" && this.surname != null && this.surname != "") {
        await axios
          .post("/admin/team/create", {
            name: this.name,
            surname: this.surname
          }).then(() => {
            this.sync();
            this.name = null;
            this.surname = null;
          })
      }
    },
    async createUsersGroup() {
      if (this.nameGroup != null && this.nameGroup != "") {
        await axios
          .post("/admin/teamGroup/create", {
            name: this.nameGroup
          }).then(() => {
            this.syncGroups();
            this.name = null;
          })
      }
    },
    async deleteItem(item) {
      await axios
        .post("/admin/team/delete", item).then(() => {
          this.sync();
        })
    },
    async deleteItemGroup(item) {
      await axios
        .post("/admin/teamGroup/delete", item).then(() => {
          this.syncGroups();
        })
    },
    async syncGroups(){
      await axios
        .get("/admin/teamGroup/get").then((res) => {
          this.groups = res.data.sort((a, b) => {
            if (parseInt(a.index_order) === 0 && parseInt(b.index_order) !== 0) {
              return 1; // Если у "a" index_order равен 0, а у "b" не равен 0, поместите "a" в конец
            } else if (parseInt(a.index_order) !== 0 && parseInt(b.index_order) === 0) {
              return -1; // Если у "b" index_order равен 0, а у "a" не равен 0, поместите "b" в конец
            } else {
              return parseInt(a.index_order) - parseInt(b.index_order); // Иначе сортируйте по index_order от меньшего к большему
            }
          });

          console.log(this.groups)
        })
    },
    async sync() {
      await axios
        .get("/admin/teamGroup/get").then((res) => {
          this.groups = res.data.sort((a, b) => {
            if (parseInt(a.index_order) === 0 && parseInt(b.index_order) !== 0) {
              return 1; // Если у "a" index_order равен 0, а у "b" не равен 0, поместите "a" в конец
            } else if (parseInt(a.index_order) !== 0 && parseInt(b.index_order) === 0) {
              return -1; // Если у "b" index_order равен 0, а у "a" не равен 0, поместите "b" в конец
            } else {
              return parseInt(a.index_order) - parseInt(b.index_order); // Иначе сортируйте по index_order от меньшего к большему
            }
          });
        }); 
      await axios
        .get("/admin/team/get").then((res) => {
          this.team = res.data.sort((a, b) => {
            const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
            const nameB = b.name.toUpperCase();

            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0; // Names are equal
          });

          this.filteredTeam = res.data.sort((a, b) => {
            const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
            const nameB = b.name.toUpperCase();

            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0; // Names are equal
          });
          ;;
        });
        
    },
  },
  created() {
    this.sync();
  }
}
</script>
<style lang="scss" scoped></style>